module.exports = __webpack_public_path__ + "img/02.15557606.png";